import { Chartisan, ChartisanHooks } from "@chartisan/chartjs";
window.Chartisan = Chartisan;
window.ChartisanHooks = ChartisanHooks;
